// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-img {
  height: 400px;
  width: 500px;
}

.rec.rec-arrow:disabled {
  visibility: hidden;
}

.carousel-div {
  margin: 50px 40px;
}`, "",{"version":3,"sources":["webpack://./src/CSS/Home.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,YAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,iBAAA;AADJ","sourcesContent":["@import './variables';\n\n.carousel-img{\n    height: 400px;\n    width: 500px;\n}\n\n.rec.rec-arrow:disabled {\n    visibility: hidden;\n}\n\n.carousel-div{\n    margin: 50px 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
